module.exports = __webpack_public_path__ + "media/images/redes_sociales/wathapp-3057ef34c0f23fe2c6ea8d161d0db9bc.svg";